<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li>
                        <router-link to="/">INICIAL</router-link>
                    </li>
                    <li class="active">CGNAT</li>
                </ol>

                <div class="row">
                    <div class="col-md-12">

                        <form class="form-horizontal">

                            <div class="panel panel-info">
                                <div class="panel-heading">CRITERIOS DE BUSCA</div>
                                <div class="panel-body">

                                    <div class="form-group">
                                        <div class="col-sm-3">
                                            <label for="mac" class="control-label">MAC</label>
                                            <input id="mac" v-model="mac" class="form-control"><br/>
                                        </div>

                                        <div class="col-sm-3">
                                            <label for="ip" class="control-label">IP</label>
                                            <input id="ip" v-model="ip" class="form-control"><br/>
                                        </div>

                                        <div class="col-sm-3">
                                            <label for="usuario" class="control-label">USUÁRIO</label>
                                            <input id="usuario" v-model="usuario" class="form-control"><br/>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="col-sm-3">
                                            <label for="data_inicial" class="control-label">DATA INICIAL</label>
                                            <input id="data_inicial" type="date" v-model="data_inicial" class="form-control"><br/>
                                        </div>

                                        <div class="col-sm-3">
                                            <label for="data_final" class="control-label">DATA FINAL</label>
                                            <input id="data_final" type="date" v-model="data_final" class="form-control"><br/>
                                        </div>
                                    </div>

                                    <button :disabled="! mac && ! usuario" @click.stop.prevent="buscar()" class="btn btn-success">
                                        BUSCAR RELATÓRIO
                                    </button>

                                </div>
                            </div>

                        </form>

                        <table v-if="contrato" id="mytable" class="table table-bordred table-striped">

                            <thead>

                                <tr>
                                    <th>MAC</th>
                                    <th>CAUSA</th>
                                    <th>STATION ID</th>
                                    <th>INÍCIO</th>
                                    <th>FINAL</th>
                                    <th style="text-align: center;width: 100px">IP</th>
                                </tr>

                            </thead>

                            <tbody>

                                <tr v-for="c in contrato" v-bind:key="c.id_log">
                                    <td>{{ c.mac }}</td>
                                    <td>{{ c.causa }}</td>
                                    <td>{{ c.station_id }}</td>
                                    <td>{{ c.data_evento_start | date("DD/MM/YYYY HH:mm:ss") }}</td>
                                    <td>{{ c.data_evento_stop | date("DD/MM/YYYY HH:mm:ss") }}</td>
                                    <td class="text-center">{{ c.ip }}</td>
                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Cgnat } from "../../class/index";
import ComboMeses from "../../components/combo/meses";
import ComboAnos from "../../components/combo/anos";
import { date } from "../../filters";
/* global moment */
export default {
    name: "BuscaClienteIpv6",
    components: {
        ComboMeses,
        ComboAnos
    },
    filters: {
        date
    },
    data() {
        return {
            mac: null,
            ip: null,
            data_inicial: moment().format("YYYY-MM-DD"),
            usuario: null,
            data_final: moment().format("YYYY-MM-DD"),
            contrato: null
        };
    },
    methods: {
        async buscar() {
            this.contrato = await Cgnat.geral({
                mac: this.mac || "",
                usuario: this.usuario || "",
                ip: this.ip || "",
                data_inicial: this.data_inicial,
                data_final: this.data_final
            });
        }
    }
};
</script>

<style scoped>
</style>
